import { render, staticRenderFns } from "./improvement_subject.vue?vue&type=template&id=8e95762a&"
import script from "./improvement_subject.vue?vue&type=script&lang=js&"
export * from "./improvement_subject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports